<div class="data-exchange">
  <div class="data-exchange__grid">

    <!-- Agrirouter -->
    <div [class.connection-card--connected]="agrirouterConnected" class="connection-card">
      <div class="connection-card__logo-area">
        <img
          class="connection-card__logo"
          src="assets/images/agrirouter/agrirouter.svg"
          alt="agrirouter" />
      </div>
      <div class="connection-card__identity">
        <span class="connection-card__company">DKE-Data</span>
        <span class="connection-card__name">agrirouter</span>
      </div>
      <hr class="connection-card__divider" />
      <p class="connection-card__description">
        {{ 'data-exchange.agrirouter-description' | translate }}
      </p>
      @if (agrirouterConnected) {
        <div class="connection-card__status connection-card__status--connected">
          <i class="agres-check"></i>
          {{ 'data-exchange.connected' | translate }}
        </div>
      } @else {
        <div class="connection-card__status connection-card__status--disconnected">
          <i class="agres-circle"></i>
          {{ 'data-exchange.not-connected' | translate }}
        </div>
      }
      <div class="connection-card__actions">
        <app-button
          [title]="agrirouterButtonTitle | translate"
          [icon]="agrirouterButtonIcon"
          color="primary"
          size="full"
          (btnClick)="goToAgrirouter()">
        </app-button>
        <app-button
          [title]="'data-exchange.learn-more' | translate"
          icon="agres-share"
          color="return"
          size="full"
          (btnClick)="learnMoreAgrirouter()">
        </app-button>
      </div>
    </div>

    <!-- Operations Center -->
    <div [class.connection-card--connected]="johnDeereStatus.connected" class="connection-card">
      <div class="connection-card__logo-area">
        <img
          class="connection-card__logo"
          src="assets/images/john-deere/john-deere-operations-center-connected.svg"
          alt="John Deere Operations Center" />
      </div>
      <div class="connection-card__identity">
        <span class="connection-card__company">{{ 'data-exchange.oc-company' | translate }}</span>
        <span class="connection-card__name">{{ 'data-exchange.oc-name' | translate }}</span>
      </div>
      <hr class="connection-card__divider" />
      <p class="connection-card__description">
        {{ 'data-exchange.oc-description' | translate }}
      </p>
      @if (johnDeereStatus.connected) {
        <div class="connection-card__status connection-card__status--connected">
          <i class="agres-check"></i>
          {{ 'data-exchange.connected' | translate }}
        </div>
      } @else {
        <div class="connection-card__status connection-card__status--disconnected">
          <i class="agres-circle"></i>
          {{ 'data-exchange.not-connected' | translate }}
        </div>
      }
      <div class="connection-card__actions">
        <app-button
          [title]="johnDeereButtonTitle | translate"
          [icon]="johnDeereButtonIcon"
          color="primary"
          size="full"
          (btnClick)="goToJohnDeere()">
        </app-button>
        <app-button
          [title]="'data-exchange.learn-more' | translate"
          icon="agres-share"
          color="return"
          size="full"
          (btnClick)="learnMoreOC()">
        </app-button>
      </div>
    </div>

  </div>
</div>
